import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'loader-view',
  templateUrl: './loader-view.component.html'
})
export class LoaderViewComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LoaderViewComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
  }
  onNoClick(): void {
  }

}
